import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { createHigherOrderComponent } from '@wordpress/compose';
import { Fragment } from '@wordpress/element';
import { InspectorControls, PanelColorSettings, ContrastChecker } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
export function withMediaManagerColors(supportProps) {
  return createHigherOrderComponent(BlockEdit => props => {
    // Panel title.
    const panelTitle = supportProps.__sectionTitle || __('Color settings', 'media-manager'); // Panel color settings.


    const colorSettings = []; // Contrast checker.

    const contrastCheckerProps = {};

    for (const prop in supportProps) {
      var _props$support$attrib, _supportProps$prop;

      if (/^__/.test(prop)) {
        continue;
      }

      const support = supportProps[prop];
      const value = (_props$support$attrib = props[support.attributeName]) === null || _props$support$attrib === void 0 ? void 0 : _props$support$attrib.color;
      colorSettings.push({
        label: (_supportProps$prop = supportProps[prop]) === null || _supportProps$prop === void 0 ? void 0 : _supportProps$prop.label,
        value,
        onChange: props[support.setterAttributeName]
      });

      if (supportProps.__contrastChecker) {
        contrastCheckerProps[support.style === 'color' ? 'textColor' : 'backgroundColor'] = value;
      }
    }

    return createElement(Fragment, null, createElement(InspectorControls, null, createElement(PanelColorSettings, {
      title: panelTitle,
      colorSettings: colorSettings
    }, supportProps.__contrastChecker && createElement(ContrastChecker, _extends({}, contrastCheckerProps, {
      isLargeText: false
    })))), createElement(BlockEdit, props));
  }, 'withMediaManagerColors');
}
//# sourceMappingURL=index.js.map